import React, { FC } from 'react';
import { Switch } from '@cokitchen/cokitchen-components';
import TimeSelector from 'components/base/time-selector';

type Props = {
  data:
    | { name: string; opening_time: Date | string; closing_time: Date | string; active?: boolean }[]
    | undefined;
  setData: (k?: any) => void;
  disabled?: boolean;
};

const WorkingHours: FC<Props> = ({ data, setData, disabled }) => {
  const updateState = (index: any, value: any) => {
    const newArray: any = data?.map((item, i) => {
      if (index === i) {
        return { ...item, [value.name]: value.value };
      } else {
        return item;
      }
    });
    setData(newArray);
  };

  return (
    <div>
      {data?.map((item: any, index) => {
        return (
          <div className='flex flex-row gap-9 items-center' key={index}>
            <p className='grow basis-1/3 capitalize'>{item.name}</p>
            <div className='flex items-center gap-5 rounded p-3 pb-4'>
              <p className='text-gray-5 text-xs leading-[19px] mb-1'>From:</p>
              <TimeSelector
                disabled={disabled}
                value={item.opening_time}
                onChange={(k) => updateState(index, { name: 'opening_time', value: k })}
              />

              <p className='text-gray-5 text-xs leading-[19px] mt-2 mb-1'>To:</p>
              <TimeSelector
                disabled={disabled}
                value={item.closing_time}
                onChange={(k) => updateState(index, { name: 'closing_time', value: k })}
              />
            </div>
            <Switch
              active={item.active}
              disabled={disabled}
              onChange={() => updateState(index, { name: 'active', value: !item.active })}
            />
          </div>
        );
      })}
    </div>
  );
};

export default WorkingHours;
